import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
interface TrustRowProps {
  dark?: boolean;
}
export function TrustRow({
  dark = false
}: TrustRowProps) {
  return <div className={`flex flex-col sm:flex-row justify-center items-center gap-1 sm:gap-5 text-[11px] sm:text-sm font-semibold text-center ${dark ? 'text-cream/90' : 'text-anthracite'}`} data-id="element-143" data-mp="22xqp6ek7gxby">
      <span className="flex items-center gap-1.5" data-id="element-144" data-mp="2crqtwfbks0k5">
        <span className="text-gold tracking-tighter" aria-hidden="true" data-id="element-145" data-mp="1p0v6rvi2dtj8">
          ⭐⭐⭐⭐⭐
        </span>
        <span data-id="element-146" data-mp="1k20m0o0jduwh">4.9/5 — Recensioni Verificate dai Running Coach</span>
      </span>
      <span className="flex items-center gap-1.5" data-id="element-147" data-mp="1yy9jbk0v9y69">
        <ShieldCheckIcon className={`w-4 h-4 shrink-0 ${dark ? 'text-gold' : 'text-navy'}`} data-id="element-148" data-mp="1yvwvwrccavlt" />
        <span data-id="element-149" data-mp="3ad4wt2ns1tl8">Garanzia Soddisfatti o Rimborsati di 14 Giorni — Zero Rischi</span>
      </span>
    </div>;
}